import { PlanningObject, TravelPassengers } from "pages/public/Planner/PlannerFlow.model";
import { getAxios, postAxios } from "services/api/api.service";
import { apiNames } from "services/api/endpoint.service";
import { getItemStorage, setItemStorage } from "services/util/sessionStorage.service";
import { aproxPrice, externalBuy, fullTrain, includedMainText, missingPlaces } from "./functions/managePricetag";
import { getSilentObject, manageTransbordosCercanias } from "./renfe.service";
import * as mocks from "./TripSelectorTrain.mock";
import { getIdaVuelta, getIdaVuelta2 } from "./FromTo.mock";
import { EAveTarifTypes, IMappedDetailObject, IReturnTrainStateControlObject, Line, PlanningObj, TripMaped } from "./TripSelectorTrain.model";
import { calcColorsTickets, calcFrecuency, getLeafClass, getTransportColor, lowerValueNumberTickets, mapNumberTickets, removeZeroTickets, RenfeTrainCodesList } from "./TripSelectorTrain.util";
import { Trip } from 'models/TripInterface';
import { getTransportIcon, UiTagData } from "services/util/util.service";
import { SessionStorageItems } from "services/user/user.session.service";
import { ITrasportSection } from "raas-ui-react-components/dist/types/components/atomic/ui-route-box/ui-route-box.model";
import { sessionLanguageMapping } from "../AveFlow/AveFlow.util";
import { getMessagesHimCard, getMessagesHimResumen } from "./functions/him";
import { checkCompleteTrains, checkCompleteTrainsWhenDeleting, convertLegIdsToNumbers } from "../TripSelector/TripSelector.util";
import { NOTES_NOT_SUPPORTED } from "../TripSelector/TripSelector.service";
import { mappingDelete, mappingDeleteAfter } from "../TripSelector/renfe.service";

declare const window: any;
// CONSTANTES
const TRANSPORTS_WITH_MULTIPLIER = ["ave", "cercanias"];
const TRAIN_ALLOWED_TARIFF = [EAveTarifTypes.BASICO, EAveTarifTypes.ELIGE, EAveTarifTypes.CONFORT, EAveTarifTypes.PREMIUM];
const TRAIN_ALLOWED_TARIFF_FROM_TO = [EAveTarifTypes.BASICO, EAveTarifTypes.ELIGE, EAveTarifTypes.CONFORT, EAveTarifTypes.PREMIUM, EAveTarifTypes.IDA_Y_VUELTA];
// const TRANSPORTS_WITH_MULTIPLIER = ["ave", "cercanias", "busLD", "metro"]; // posibles transportes para multiplicar
export enum travelServices {
  train = "TRAIN",
  ave = "AVE"
}


/**
 * @description llamada a viajes
 * @param query 
 * @param callback 
 * @param errorCallback 
 * @param mock 
 */
export function TripCall(query: any, callback: Function, errorCallback: Function, removeLoading: boolean, mock?: string) {
  if (mock === "true") {
    const mock = mocks.getAve();
    try {
      sessionStorage.setItem('raas-trip-mock-data', JSON.stringify(mock));
    } catch (error) {
      sessionStorage.setItem('raas-trip-mock-data', 'error saving mock');
    }
    callback(mock);
  } else {
    getAxios(apiNames.PLAN, false, query, removeLoading).then((data: any) => {
      callback(data);
    }).catch((error: any) => {
      errorCallback(error)
    })
  }
}

export function getSeatTrainMapCallPromise(shpCtx: string) {
  const body = { tariffs: [{ context: shpCtx }] };
  return postAxios(apiNames.BKING, false, '/bookings/seats', body)
}

function _getDate(formDate: Date) {
  const todayDate = new Date();
  return (new Date(formDate).getTime() <= todayDate.getTime()) ? todayDate : formDate;
}

/**
 * @description función que genera la query para la llamada
 * @param body 
 * @param byCord 
 * @returns 
 */
export function mapTripQuery(body: PlanningObject, transportFilter: string, isTheFirstLeg: boolean, moreTime?: boolean, leesWalk?: boolean, byCord?: boolean): string {

  const date = _getDate(body.departureDate.value) || new Date();
  const originExtId = `originExtId=${body.origin.value.id}`;
  const destExtId = `&destExtId=${body.destination.value.id}`;
  const departureDate = `&date=${getISODate(date)}`;
  const returnDate = getISODate(body?.arrivalDate?.value);
  const travellerProfileData = { "version": 1, "genericParameters": { "returnDate": `${returnDate}` } };
  const traveller = body?.return && isTheFirstLeg
    ? `&travellerProfileData=${encodeURI(JSON.stringify(travellerProfileData))}`
    : ``;


  return [originExtId, destExtId, departureDate, traveller].join("");
}

export function mapErrorNotes(Notes: any) {
  if (!!Notes?.Note) {
    return Notes?.Note?.map(errorNoteType)
  }
}

export function errorNoteType(note: any) {
  if (!!note?.value && note?.value?.includes("No valid offers")) {
    return 'full-train';
  }
  if (!!note?.key && note?.key?.includes("text.connection")) {
    return 'error-connection';
  }
  return null;
}

export function isFullTrain(infoNote: Array<string>) {
  return !!(Array.isArray(infoNote) && infoNote?.find(n => n == 'full-train'))
}

/**
 * @description función que mapea los viajes para el card de viaje
 * @param trip 
 * @returns 
 */
export function mapResultTrip(trip: any, planningObject: PlanningObject, t: any, _travellerList: any, _dateTripPlan: number, isReturnTrip: boolean): TripMaped {
  const { diff } = getTimeBetween(trip);
  const dateTimeInfo: { departureTime: string; totalTime: string; tripDayPlanified: boolean, origenHour: string } = getDepartureTime(trip, _dateTripPlan);
  const trasportSection = getTransportSection(trip.LegList.Leg, trip);
  const ecologicSection = getEcologicSection(trip.Eco?.rating, trip.Eco?.co2);
  let externalPurchase = false; // Mostrar Compra externa en la card

  let tarifs: any[] = getTarifsPerPST(trip);
  let incidentsHim: any = getMessagesHimCard(trip)




  // CONTROL SI HAY TRANSBORDOS
  let tarifsArrayModified: Array<any> = [];

  const isAveTrain = trasportSection?.filter((i: any) => i?.icon === "ave");

  let isFullTrainAve: boolean;

  if (isAveTrain.length > 0) {
    trip.LegList.Leg?.forEach((element: any) => {
      const notes = mapErrorNotes(element?.Notes);
      isFullTrainAve = isAveTrain && (isAveTrain && !!notes && isFullTrain(notes));
    });
  }

  // METRO
  let transportArrayList = trasportSection;
  // CERCANIAS: Si hay transbordo o si está incluido en ave, no se guarda la tarifa correspondiente.
  transportArrayList = transbordoCercanias(trip, transportArrayList);
  const hasTransbordosRenfe = transportArrayList?.filter((i: any) => i?.isTransbordoRenfe || i?.isIncludedByAve)?.length > 0;
  if (hasTransbordosRenfe) {
    tarifsArrayModified = transportArrayList.map((element: any) => {
      if (element.icon === 'cercanias' && (element?.isIncludedByAve === false && element?.isTransbordoRenfe === false)) {
        return tarifs?.[element?.idx];
      } else if (element.icon !== 'cercanias') {
        if (element.icon === "ingreso") {
          return undefined;
        }
        return tarifs?.[element?.idx];
      }
    });
  } else {
    tarifsArrayModified = [...tarifs];
  }

  let priceInfo = tarifsArrayModified ? calcPriceTagFromTarifs(tarifsArrayModified, t, _travellerList, transportArrayList, isReturnTrip) : { literal: "" }; // revisar 2
  let priceNumber = priceInfo?.price ? priceInfo?.price : 0;
  let priceTrip = priceInfo?.literal ? priceInfo.literal : ""; // revisar 2


  let { price, hideDetail } = tripWithMissingTarif(trip, _travellerList, priceTrip, priceNumber);

  price = hideDetail ? price : formatPriceByType(priceInfo.price || price, trip?.LegList?.Leg, t);

  const hasExternalBuyInTheTrip = (currentValue: any) => currentValue?.icon?.includes("metro") || currentValue?.icon?.includes("busLD") || currentValue?.text?.includes("ALSA") || (currentValue?.icon === "cercanias" && price === "")
  const externalTransportOrFree = (currentValue: any) => currentValue?.icon?.includes("metro") || currentValue?.icon?.includes("busLD") || currentValue?.text?.includes("ALSA") || currentValue?.icon === "andar" || (currentValue?.icon === "cercanias" && price === "") || (currentValue?.icon === "ave" && price === "full-train" || isFullTrainAve === true);
  const onlyExternalTransportOrFree = trasportSection?.every(externalTransportOrFree);

  externalPurchase = trasportSection?.some(hasExternalBuyInTheTrip);
  // DOCO-58. Criterio de aceptación: Si un viaje solo contiene transportes informativos y no se tiene esa tarifa en lugar del precio aparece un guion (-€)
  if (onlyExternalTransportOrFree && (price?.includes('0,00') || price == "")) {
    price = "- €";
  }

  let transportsArray = trasportSection.map((item: any) => ({ ...item, text: item.text?.toLowerCase() == 'karhoo' ? item.transportTypeString : item.text }))
  transportsArray = filterWalkingCards(transportsArray);

  if (lowerValueNumberTickets(priceInfo.numberTicketsArray) === 0 && priceInfo.price === 0 && priceInfo.literal === "Desde 0,00 €") {
    price = "- €";
    priceInfo.numberTickets = "No"
  }

  let textTickets, numberTickets, colorTickets
  let isTrainComplete = checkCompleteTrains(trip.LegList.Leg)


  if (isTrainComplete === false) {
    let result
    if (lowerValueNumberTickets(priceInfo.numberTicketsArray) === 0) {
      result = t('literals.missingPlaces');
    } else {
      if (priceInfo?.numberTicketsArray?.length !== 0) {
        result = `${lowerValueNumberTickets(priceInfo.numberTicketsArray)} ${lowerValueNumberTickets(priceInfo.numberTicketsArray) === 1 ? t('literals.numberTicketAvailable') : t('literals.numberTicketsAvailable')}`
      }

    }
    if (priceInfo.numberTickets !== "0") {
      numberTickets = lowerValueNumberTickets(priceInfo.numberTicketsArray);
      textTickets = result;
      colorTickets = calcColorsTickets(lowerValueNumberTickets(priceInfo.numberTicketsArray)) // rojo
    }
  } else {
    numberTickets = lowerValueNumberTickets(priceInfo.numberTicketsArray);
    textTickets = t('literals.fullTrain');
    colorTickets = calcColorsTickets(0 as any);
  }

  const output = {
    ...dateTimeInfo,
    sortInfo: {
      //price: priceInfo.price,
      price: 0,
      duration: diff,
      ecologic: trip?.Eco?.rating || 0,
      co2: trip?.Eco?.co2,
    },
     price:"",
    ecologicSection,
    trasportSection: transportsArray,
    //hideDetail,
    hideDetail:false,
    hasExternalBuy: externalPurchase,
    incidentsHim: incidentsHim,
    numberTicketsAvailable: {
      number: numberTickets,
      text: textTickets,
      color: colorTickets // rojo
      //B38900 amarullo
    }

  }
  return output
}
/** DOCO-673 
  - El usuario solo verá los tramos a pie de más de 10 min en la card de rutas. 
    Excepto si la ruta es solo andando, en ese caso se mostrará cualquier duración de trayecto.
  - Los trayectos a pie se mantendrán en el detalle de la ruta.
*/
const filterWalkingCards = (transportsArray: Array<any>) => {
  const arrayFinal = transportsArray.length === 1 ? transportsArray : transportsArray.filter((item: any) => !(item.icon == "andar" && parseInt(item.text) < 10))
  return arrayFinal;
}

const getDepartureTime = (trip: Trip, _dateTripPlan: number) => {
  const { originDay, destinationDay, originHour, originMinutes, destinationHour, destinationMinutes, diff } = getTimeBetween(trip);
  const arrivalTomorrow = destinationDay > _dateTripPlan; // cuando la fecha de llegada es al dia siguiente.
  const tripDayPlanified = originDay === _dateTripPlan; // cuando la fecha de salida el mismo dia del planificado.
  let departureTime = `${[originHour, originMinutes].join(":")} - ${[destinationHour, destinationMinutes].join(":")} ${arrivalTomorrow ? '(+1)' : ''}`;     //    (+1)
  let totalTime = `${Math.floor(diff / 1000 / 60 / 60)}h ${diff / 1000 / 60 % 60}min`;
  return {
    origenHour: originHour + originMinutes,
    departureTime,
    totalTime,
    //tripDayPlanified: getItemStorage('raas-trip-mock') == true ? true : tripDayPlanified // si estoy trabajando con un mock, que el dia planificado sea true a fuego.
    tripDayPlanified: true  // si estoy trabajando con un mock, que el dia planificado sea true a fuego.
  }
}

/**
 * Devuelve verdadero si hay más de un transporte distinto en el viaje (multimodal)
 * @param transports Array de transportes obtenidos del Leg
 * @returns {boolean} Devuelve si en el array de viajes, simplificado por transportes unicos, hay más de 1 transporte distinto.
 */
function isMultimodalTrip(transports: any[]) {
  const uniqueTransports = transports.filter((element: string, index: number) => transports.indexOf(element) === index);
  return uniqueTransports.length > 1;
}

export function formatPriceByType(price: any, legs: any, t: Function) {
  const arrayPrepago = ['ave', 'cercanias'];

  const transports = legs?.map((leg: any) => switchTransports(leg)).filter((transport: any) => transport.icon !== 'andar' && transport.icon !== 'transbordo' && transport.icon !== 'ingreso');
  const hasPrepago = !!transports.find((transport: any) => arrayPrepago.includes(transport.icon));

  //const isMultitrip = isMultimodalTrip(transports);

  if (hasPrepago) {
    return (typeof price === 'number' && price > -1) ? `${formatPrice(price)} €` : '' as any;
  }
  // /* Cuando es unimodal y es movitaxi - OK */
  // if (!isMultitrip) {
  //   return (typeof price === 'number' && price > -1) ? `<span class="small-size">${t('literals.fixedPrice')}</span> ${formatPrice(price)} €` : '';
  // }
  // /* Solo pospagos - OK */
  // else if ( !hasPrepago) {
  //   return (typeof price === 'number' && price > -1) ? `<span class="small-size">${t('literals.since')}</span> ${formatPrice(price)} €` : '';
  // }
  // /* Solo prepagos - OK */
  // else if (hasPrepago ) {
  //   return (typeof price === 'number' && price > -1) ? `${formatPrice(price)} €` : '';
  //   //return (typeof price === 'number' && price > -1) ? `<span class="small-size">${t('literals.since')}</span> ${formatPrice(price)} €` : '';
  // }
  // /* Prepago + pospago - OK */
  // else if (hasPrepago && hasPospago) {
  //   return (typeof price === 'number' && price > -1) ? `<span class="small-size">${t('literals.since')}</span> ${formatPrice(price)} €` : '';
  // } else {
  //   /* Aqui puede entrar al caso solo bus o solo metro y se muestra el precio sin nada delante. */
  //   // console.log('caso no cubierto: ', { transports, hasPrepago, hasPospago, hasMovitaxi, isMultitrip });
  //   return (typeof price === 'number' && price > -1) ? `${formatPrice(price)} €` : '';
  // }
}
export function tripWithMissingTarif(trip: any, _travellerList: any, _price?: string, priceTrip?: number) {
  const travellerNumber = getPassengerNumber(_travellerList?.value);
  let price = _price ? _price : "";
  let hideDetail: boolean = false;
  let karhooNotValidTarif = false;
  let isFullTrain = false;
  let realPrice;
  // comprobar las tarifas y que los transportes renfe tengan precio.
  trip?.LegList?.Leg?.forEach((leg: any, index: number) => {
    // si el leg es un transporte,
    const transports = ["TAXI", "JNY"];
    if (transports.includes(leg.type)) {

      let found = null;
      // compruebo que tenga tarifa
      found = trip?.TariffResult?.fareSetItem?.find((fare: any) => {
        if (index >= convertLegIdsToNumbers(fare.fromLegId || fare.fromLeg) && index <= convertLegIdsToNumbers(fare.toLegId || fare.toLeg)) return fare;
      })
      if (found?.name === "Renfe AVE LD MD Pricing") {
        let tariffByPst: any[] = getTarifsPerPST(trip);
        if (priceTrip === 0 || tariffByPst?.[index]?.length === 0) {
          price = "";
          hideDetail = true;
        }
      }
      if (!found) {
        // si no encuentra tarifa y es cercanías lo regalamos, hasta que traigan bien la tarifa de hafas
        const { icon } = switchTransports(leg);
        if (icon === "ave") {
          const infoNote = mapErrorNotes(leg?.Notes);
          if (Array.isArray(infoNote)) {
            // console.log(infoNote, infoNote.find(n => n == 'error-connection'));
            if (infoNote.find(n => n == 'full-train')) {
              isFullTrain = true;
              hideDetail = false;
            }
            else if (!!infoNote.find(n => n == 'error-connection')) {
              hideDetail = true;
            }
          }
          else {
            price = "";
            hideDetail = true;
          }
        }
        else if (!hideDetail && icon != "cercanias" && icon !== "busLD") {
          price = "";
          hideDetail = false;
        }
      }
    }
  })

  return {
    price: hideDetail ? '' : price,
    hideDetail,
    karhooNotValidTarif,
    isFullTrain
  }
}

function isAveFromTarifs(items: any[]) {
  let output: boolean = false;
  items.forEach((item: any) => {
    if (item?.name?.toLowerCase() === "providerId".toLowerCase()) {
      if (item.value.toLowerCase() === "Renfe".toLowerCase()) output = true;
    }
  })
  return output;
}

/**
 * @description función que monta el array de tarifas, que se usará luego para setear las tarifas de las legs del trayecto
 * se lanza al pulsar en un viaje.
 * @param fareSetItem 
 * @returns 
 */
export function getTarifs(fareSetItem: any) {
  let tarifs: any[] = [];
  fareSetItem.forEach((el: any, i: number) => {
    let index = convertLegIdsToNumbers(el?.fromLegId || el?.fromLeg);
    let lastIndex = convertLegIdsToNumbers(el?.toLegId || el?.toLeg);
    let tarifas: any[] = [];

    if (el?.fareItem) {
      let tickets = el?.fareItem[0]?.ticket;

      tickets?.forEach((ta: any, index: number) => {
        if (ta.cur === "EUR") {
          tarifas.push({
            price: ta.price / 100,
            currency: ta.cur,
            desc: ta.desc || ta.name,
            param: ta.param,
            shpCtx: ta.shpCtx,
            id: `CODE-${index}`,
            group: ta?.group,
            isFromTo: ta?.group?.type === EAveTarifTypes.IDA_Y_VUELTA,
            fareName: el.name,
            fareSetItemIndex: i,
            numberTickets: ta?.param.find((item: any) => item?.name === "AVAILABILITY"),
            idTariff: el?.fromLegId || el?.fromLeg
          })
        }
      });

      // Filtrado si son AVE y viene 0€
      if (el.name === 'Renfe AVE LD MD Pricing') {
        tarifas = tarifas.filter((ticket: any) => ticket.price !== 0);
      }
    }

    if (index === lastIndex) {
      tarifs[index] = tarifas;
    } else {
      while (index < lastIndex) {
        if (tarifs[index]) {
          tarifs[index] = tarifs[index].concat(tarifas);
        } else {
          tarifs[index] = tarifas;
        }
        index++;
      }
    }
    // ordenamos las tarifas desde más baratas
    tarifs.forEach((tar: any) => {
      tar.sort((a: any, b: any) => {
        return a.price - b.price;
      });
    })
  });

  return tarifs
}

const getNormalTarif = (tarifsArray: any, isReturnTrip: boolean) => {
  const allowedTypeArray = isReturnTrip ? TRAIN_ALLOWED_TARIFF_FROM_TO : TRAIN_ALLOWED_TARIFF;
  return tarifsArray?.filter((item: any) => allowedTypeArray.includes(item?.group?.type) && item?.group?.child === false && !item?.group?.discount);
}

const getNormalTarifWithChildren = (tarifsArray: any, isReturnTrip: boolean) => {
  const allowedTypeArray = isReturnTrip ? TRAIN_ALLOWED_TARIFF_FROM_TO : TRAIN_ALLOWED_TARIFF;
  return tarifsArray?.filter((item: any) => allowedTypeArray.includes(item?.group?.type) && !item?.group?.discount);
}

const checkPassengerNumber = (tarifsArray: any, passengerNumber: number) => {
  return tarifsArray?.filter((tarif: any) => {
    const availableSeatObject = tarif?.param?.find((item: any) => item?.name === "AVAILABLE_SEATS");
    return !!availableSeatObject ? +availableSeatObject?.value >= passengerNumber : tarif
  });
}

export function filterAveTariff(tarifsArray: any, child: boolean, isReturnTrip: boolean) {
  let tariffFiltred = [];
  if (tarifsArray) {
    tariffFiltred = child ? getNormalTarifWithChildren(tarifsArray, isReturnTrip) : getNormalTarif(tarifsArray, isReturnTrip);
  }
  return tariffFiltred?.length > 0 ? tariffFiltred : tarifsArray;
}

const getPassengerNumber = (planningObject: any): number => {
  const passagerNumberArray = Object.values(planningObject);
  const sum: number = passagerNumberArray.reduce(
    (prev: any, current: any) => prev + current,
    0
  ) as number;
  return sum;
};

export function filterKarhooTarif(tarifsArray: any, travellersList: any) {
  const passengerTavellersNumb = getPassengerNumber(travellersList?.value);

  let tariffFiltred = [];
  if (tarifsArray) {
    tariffFiltred = checkPassengerNumber(tarifsArray, passengerTavellersNumb);
  }
  return tariffFiltred;
}



/** Obtiene tarifas para cada PST de la ruta seleccionada */
export function getTarifsPerPST(trip: any) {
  let tarifs: any[] = [];
  if (trip && trip?.TariffResult?.fareSetItem) {
    tarifs = getTarifs(trip?.TariffResult?.fareSetItem);
  }
  return tarifs;
}

function getReturnTarif(items: any[]) {
  let output: boolean = false;
  items?.forEach((item: any) => {
    if (item?.name?.toLowerCase() === "TYPE".toLowerCase()) {
      if (item?.value?.toLowerCase() === "RETURN".toLowerCase()) output = true;
    }
  })
  return output;
}

export function getRenfeTarifs(fareSetItem: any) {
  const renfeTarif = fareSetItem?.filter((item: any) => isAveFromTarifs(item?.param));
  return !!fareSetItem ? renfeTarif?.filter(Boolean) : [];
}

export function getTrainReturnList(fareSetItem: any) {
  const returnTrainList = fareSetItem?.fareItem?.filter((item: any) => getReturnTarif(item?.param));
  return !!fareSetItem ? returnTrainList?.filter(Boolean) : [];
}

const getJustFormToTarif = (tarifsArray: any) => {
  const allowedTariff = [EAveTarifTypes.IDA_Y_VUELTA];
  return tarifsArray?.map((tariff: any) => {
    const fromToTarif = tariff?.ticket?.find((item: any) => allowedTariff?.includes(item?.group?.type) && item?.group?.child === false && !item?.group?.discount);
    return !!fromToTarif ? {
      ...tariff,
      ticket: fromToTarif
    } : undefined;
  })
}


/** Obtiene tarifas de vuelta para cada PST de la ruta seleccionada */
export function getReturnTrainList(trip: any) {
  let returnTrainList: any[] = [];
  if (trip?.TariffResult?.fareSetItem) {
    const renfeTarifsList = getRenfeTarifs(trip?.TariffResult?.fareSetItem);

    renfeTarifsList.forEach((item: any, index: number) => {
      const trainWithReturn = getTrainReturnList(renfeTarifsList[index]);
      returnTrainList[convertLegIdsToNumbers(item.fromLegId)] = getJustFormToTarif(trainWithReturn);
    })

  }
  return returnTrainList;
}

/**
 * @description función que mapea los datos de un trip y retorna el detalle
 * @param trip 
 * @returns 
 */
export function mapTripToDetail(trip: any, travellersList: any, isReturnTrip: boolean, userConnected?: any, t?: any): TripDetail[] {

  let output: TripDetail[] = [];
  let legsWithDelete: any[] = checkDetailDeleteItems(trip);
  let tarifs: any[] = getTarifsPerPST(trip);
  let tarifsTransport: any[] = getTarifsTransport(trip);
  const returnTrainList: any = getReturnTrainList(trip);

  const silentObject = getSilentObject(trip, travellersList);


  trip?.LegList?.Leg?.forEach((el: any, index: number) => {
    let { originHour, originMinutes, destinationHour, destinationMinutes, diff } = getTimeBetween(el);
    let nameFloat = ""
    if (el.name === "Karhoo") {
      nameFloat = checkTripName(el, trip);
    }
    const lineTag = switchTransports(el, 0, nameFloat);

    let { icon, transportTypeString, backgroundcolor } = lineTag;
    const isWalk: boolean = (icon == "andar" || icon == "transbordo" || icon == "ingreso");
    const isRenfeTrain: boolean = icon === "ave";
    const isCercanias: boolean = icon === "cercanias";

    // let freq = el.Freq ? `${calcFrecuency((el.Freq.waitMaximum + el.Freq.waitMinimum) / 2)} min` : "";
    let freq = el.Freq ? calcFrecuency((el.Freq.waitMaximum + el.Freq.waitMinimum) / 2) : "";

    let tarifsArrayAdult = isRenfeTrain ? filterAveTariff(tarifs[index], false, isReturnTrip) : isWalk ? [] : tarifs[index] || [];
    let tarifsArrayFull = isRenfeTrain ? filterAveTariff(tarifs[index], true, isReturnTrip) : isWalk ? [] : tarifs[index] || [];

    let pricetag = isCercanias ? calcPriceCercaniasTag(tarifsArrayFull, tarifsArrayAdult, t, icon, travellersList) : calcPriceTag(tarifsArrayFull, tarifsArrayAdult, t, icon, travellersList);


    const externalList = ['EMT', 'CMT', 'CRT', 'TMB', '300', '110'];

    const isExternal = externalList.includes(el.category) || (!!el.Notes && tarifsArrayFull?.length === 0) /*Si existen notas, el cercanias es external*/
    const hasSilentCar = silentObject?.find((item: any) => item?.index == el?.idx)

    /* Tren completo en AVE */
    const notes = mapErrorNotes(el?.Notes);
    const isFullTrainAve = isRenfeTrain && (isRenfeTrain && !!notes && isFullTrain(notes));

    /* Transbordo entre metros */ // TODO: REFACTORIZAR 

    /* Transbordo entre cercanias */
    let isCercaniasTransbordo: boolean = false;
    let isCercaniasIncludedByAve: boolean = false;
    if (isCercanias) {
      const { isTransbordo, isIncludedByAve } = manageTransbordosCercanias(trip, index);
      isCercaniasTransbordo = isTransbordo;
      isCercaniasIncludedByAve = isIncludedByAve;
    }

    /* Casos de precios informativos */   /* TODO: refactorizar */
    let preciosInformativos =
      isFullTrainAve ? fullTrain(t) : isExternal ? externalBuy(t, pricetag?.price) : !!getPricePerTime(el, index) ? aproxPrice(pricetag.price as any) : pricetag;

    /* Cuando es un transbordo o primer cercanias incluido por ave, mostrar billete incluido */
    if (isCercaniasTransbordo || isCercaniasIncludedByAve) {
      preciosInformativos = includedMainText(t) as any
    }

    // cuando este cercanias no es operada por renfe, se le trata como compra externa.
    if (transportTypeString === ETransportLiterals.train) {
      preciosInformativos = externalBuy(t, pricetag?.price)
    }


    const isFromToTrainTrip = tarifs[index] ? tarifs[index].some((item: any) => { return !!item.isFromTo }) : false;

    const stops = getStops(el);

    if (isFullTrainAve) {
      preciosInformativos = fullTrain(t)
      pricetag = fullTrain(t)
    } else if (pricetag.id === undefined && pricetag.price === 0 && icon != "cercanias") {
      preciosInformativos = missingPlaces(t)
      pricetag = missingPlaces(t)
      tarifsArrayAdult = []
    }

    output.push({
      idPst: index.toString(),
      idTariff: pricetag?.idTariff,
      tripId: el.id,
      idPstNotChangeable: hasSilentCar?.index?.toString() || index?.toString(),
      departureDate: el?.Origin.date,
      arrivalTime: [destinationHour, destinationMinutes].join(":"),
      departureTime: [originHour, originMinutes].join(":"),
      direction: isWalk ? el.Destination.name : el.direction || el.Destination.name,
      icon: icon,
      transportTypeString,

      isExternal: isExternal, // evitamos que se muestre el tooltip en "billete incluido en el metro"
      transport: isWalk ? false : true,
      tarifs: tarifsArrayAdult || [],
      allTarifsList: tarifs[index] || [],
      frecuency: freq,
      realPriceTag: pricetag,
      pricetag: preciosInformativos,
      stops: stops,
      //direct:el.name==="Movitaxi" || el.name==="Karhoo" || el.name==="Cooltra",
      direct: false,
      //showFooter: legsWithDelete.find((el) => el.index === index)?.delete,
      showFooter: false,
      line: { ...lineTag, text: lineTag.text },
      duration: `${(diff / 1000 / 60 / 60 >= 1 ? Math.floor(diff / 1000 / 60 / 60) + ' h' : '')} ${diff / 1000 / 60 % 60 != 0 ? diff / 1000 / 60 % 60 + ' min' : ''}`,
      showDrivingLicense: el.name === "cooltra" /* && userConnected.docs??? */,
      literals: el.name === "cooltra" ? {
        actionStart: t("literals.findMotorcycleNearby"),
        actionEnd: t("literals.parkNear")
      } : { action: getActionLiteral(el, t) },
      pricePerTime: getPricePerTime(el, index),
      estimated: !!getPricePerTime(el, index),
      trip: el,
      silentCar: hasSilentCar,
      fromToTrainTrip: {
        returnTrainList: isFromToTrainTrip ? returnTrainList[index] : [],
        isFromToTrainTrip: isFromToTrainTrip
      },
      stationName: null,
      tarifsTransport: filterTarifsPublicTransport(el, isExternal, tarifsTransport),
      messages: getMessagesHimResumen(el, icon, backgroundcolor, t),
    })
  })
  return output;
}


export function mapTripToSummary(trip: any, travellers: string | number) {
  if (trip) {
    let originDate = new Date(trip.Origin.date.replace(/-/g, '/') + " " + trip.Origin.time)
    let destinationDate = new Date(trip.Destination.date.replace(/-/g, '/') + " " + trip.Destination.time)
    return {
      tripdate: formatWeekdayAndDateMonthToLiteral(originDate),
      triptime: `${formatTimeToLiteral(originDate)} - ${formatTimeToLiteral(destinationDate)}`,
      travellers
    }
  }
}

export function getActionLiteral(el: any, t: any): string {
  const { iconReal } = switchTransports(el);
  switch (iconReal) {

    case "ave":
      return t("getActionLiteral.stationTakeTrain")
      break;
    case "cercanias":
      return t("getActionLiteral.stationTakeSuburban")
      break;

    case "tren":
      return t("getActionLiteral.stationTakeTrain")
      break;
  }
  return "";

}

export function checkTripName(el: any, trip?: any) {
  let aux = el.Product[0];
  if (aux.name === "RENAVANT") {
    return aux.number || "AVANT";
  }
  return aux.name
}

export function getPricePerTime(el: any, index: number): string | any {
  try {
    if (!!(el.Origin.Notes.Note[index].key.includes(NOTES_NOT_SUPPORTED))) {
      return el.Origin.Notes.Note[index].value.replace('.', ',');
    }

  } catch (error) {
    return '';
  }
}
/**
 * @description función que calcula el precio de los items del detall
 * @param tarifsArray 
 * @returns 
 */




/**
 * @description función que revisa si el Array es vacia
 * @param arrayToCheck 
 * @return boolean
 */
export function isEmptyArray(arrayToCheck = []) {
  return arrayToCheck?.length === 0;
}
function transbordoCercanias(trip: Trip, transport: Array<any>) {
  const transbordos = transport.map((t: any, index: number) => {
    const { isTransbordo, isIncludedByAve } = manageTransbordosCercanias(trip, index);
    return {
      ...t,
      isTransbordoRenfe: isTransbordo,
      isIncludedByAve: isIncludedByAve
    }
  })
  return transbordos;
}


/**
 * @description función que calcula el precio total de cada uno de los viajes
 * @param tarifsArray 
 * @returns 
 */
export function calcPriceTagFromTarifs(tarifsArray: any, t: any, _travellerList: any, trasportSection: any[], isReturnTrip: boolean): { literal: string, price?: any, numberTickets?: any, numberTicketsArray?: any } {
  let sum = 0;
  let numberTickets = "Si"
  let multiTarif = false;
  let _trasportSection = trasportSection; // .map(el => el.icon !== "andar" ? el : undefined);
  let numberTicketsArray = [] as any;
  // control de no traer tarifas
  if (tarifsArray.length === 0) return { literal: "" };

  tarifsArray?.forEach((tarifs: any, index: number) => {
    const transport = _trasportSection[index] //  || _trasportSection.find(item => item?.idx === index);

    const filteredTarifs = TRANSPORTS_WITH_MULTIPLIER.includes(transport?.icon) ? getNormalTarifWithChildren(tarifs, isReturnTrip) : [];
    let tarifsList = isEmptyArray(filteredTarifs) ? tarifs : filteredTarifs;

    if (TRANSPORTS_WITH_MULTIPLIER.includes(transport?.icon)) {
      if (transport?.icon === "cercanias" && (transport.isTransbordoRenfe || transport.isIncludedByAve)) {
        sum += 0;
      } else {
        const auxPrice = getTotalPriceFromtravellerListCard(tarifsList, _travellerList, t)
        sum += auxPrice;

        if (transport?.icon !== "cercanias") {
          numberTickets = getTotalNumberTickets(tarifsList, _travellerList, t)

          if (numberTickets === undefined || auxPrice === 0) {
            numberTickets = '0'
            sum = 0
            numberTicketsArray.push({ id: index, numberTickets: 0 })
          } else {
            numberTicketsArray.push({ id: index, numberTickets: mapNumberTickets(numberTickets) })
          }
        } else {
          numberTicketsArray.push({ id: index, numberTickets: mapNumberTickets('Si') })
        }
      }
    } else {
      const auxPrice = getTotalPriceFromtravellerList(tarifsList, _travellerList);
      sum += auxPrice > 0 ? auxPrice : tarifsList?.[0]?.price || 0;
      numberTickets = getTotalNumberTickets(tarifsList, _travellerList, t)
      // sum += tarifsList[0]?.price || 0;
    }
    if (tarifsList?.length > 1 || transport?.icon === "taxiVtc") multiTarif = true;
  })
  //Posible perdida de centimo 
  //sum = Math.floor(sum * 100) / 100;
  let literalBefore = multiTarif ? t("literals.since") : t("literals.approx");
  if (numberTicketsArray.length >= 2) {
    numberTicketsArray = removeZeroTickets(numberTicketsArray)
  }
  return {
    literal: `${literalBefore} ${formatPrice(sum)} €`,
    price: sum,
    numberTickets,
    numberTicketsArray
  }
  // return `${literalBefore} ${formatPrice(sum)} €`;
}



/**
 * @description función que calcula el precio de los trayectos dependiendo de los travellers con la tarifa más barata
 * @param tarifs 
 * @param travellerList 
 * @returns 
 */
export function getTotalPriceFromtravellerList(tarifs: any[], travellerList: any) {
  const adults = travellerList.value["more-than-13-counter"];
  const children = travellerList.value["less-than-13-counter"];
  let sum = 0;
  let numberTickets = "Si"

  if (tarifs && tarifs.length > 0) {
    if (children > 0) {
      let tarif = getFirstTarif(tarifs, true, false, children);
      let price = tarif && tarif.price ? tarif.price : 0;
      sum += price * children;
    }
    if (adults > 0) {
      let tarif = getFirstTarif(tarifs, false, false, adults);

      let price = tarif && tarif.price ? tarif.price : 0;
      sum += price * adults;
    }
  }
  return sum;
}

/**
 * @description función que calcula el precio de los trayectos dependiendo de los travellers con la tarifa más barata
 * @param tarifs 
 * @param travellerList 
 * @returns 
 */
export function getTotalPriceFromtravellerListCard(tarifs: any[], travellerList: any, t: any) {
  const adults = travellerList.value["more-than-13-counter"];
  const children = travellerList.value["less-than-13-counter"];

  let sum = 0;

  if (tarifs && tarifs.length > 0) {
    if (children > 0) {
      let tarif = getFirstTarifRoundTrip(tarifs, true, false, children);
      let price = tarif && tarif.price ? tarif.price : 0;
      sum += price * children;
    }
    if (adults > 0) {
      let tarif = getFirstTarifRoundTrip(tarifs, false, false, adults);
      let price = tarif && tarif.price ? tarif.price : 0;
      sum += price * adults;
    }
  }
  return sum;
}

export function getTotalNumberTickets(tarifs: any[], travellerList: any, t: any) {
  let adults = travellerList.value["more-than-13-counter"];
  let children = travellerList.value["less-than-13-counter"];
  let numberTickets = "Si";
  if (tarifs && tarifs.length > 0) {
    if (children > 0) {
      let tarif = getFirstTarifRoundTrip(tarifs, true, false, adults + children);
      let price = tarif && tarif.price ? tarif.price : 0;
      numberTickets = tarif?.numberTickets?.value
    }
    if (adults > 0) {
      let tarif = getFirstTarifRoundTrip(tarifs, false, false, adults + children);
      numberTickets = tarif?.numberTickets?.value

    }
  }
  return numberTickets;
}



/**
 * @description función que calcula el precio de los trayectos dependiendo de los travellers con la tarifa más barata
 * @param tarifs 
 * @param travellerList 
 * @returns 
 */
export function getTotalPriceFromtravellerListByTarif(trip: any, idPst: number, travellerList: any, tarifName: string) {
  const adults = travellerList.value["more-than-13-counter"];
  const children = travellerList.value["less-than-13-counter"];
  const tarifsTrip = getTarifs(trip?.TariffResult?.fareSetItem);
  const tarifsLeg = tarifsTrip[idPst];
  let sum = 0;
  if (tarifsLeg && tarifsLeg.length > 0) {
    if (children > 0) {
      let tarif = getTarifByType(tarifsLeg, true, tarifName);
      let price = tarif && tarif.price ? tarif.price : 0;
      sum += price * children;
    }
    if (adults > 0) {
      let tarif = getTarifByType(tarifsLeg, false, tarifName);
      let price = tarif && tarif.price ? tarif.price : 0;
      sum += price * adults;
    }

  }


  return sum;
}

/**
 * @description función que coge la tarifa más barata dependiendo si es child or adult
 * @param tarifsList 
 * @param children 
 * @returns 
 */
function getFirstTarifAux(tarifsList: any[], children: boolean, discount?: boolean) {
  return tarifsList?.find(el => {
    if (el?.group) {
      if (!!discount) {
        return children ? el.group?.child && el.group.discount : !el.group?.child && el.group.discount;
      } else {
        return children ? el.group?.child && !el.group.discount : !el.group?.child && !el.group.discount;
      }
    } else {
      return el;
    }
  })
}

/**
 * @description función que coge la tarifa más barata dependiendo si es child or adult
 * @param tarifsList 
 * @param children 
 * @returns 
 */
function getFirstTarif(tarifsList: any[], children: boolean, discount?: boolean, passager?: any) {
  return tarifsList?.find(el => {
    if (el?.group) {
      if (!!discount) {
        return children ? el.group?.child && el.group.discount : !el.group?.child && el.group.discount;
      } else {
        //return children ? el.group?.child && !el.group.discount : !el.group?.child && !el.group.discount;
        if (el.group.child === children) {
          switch (el.group.type) {
            case 'BASICO':
            case 'ELIGE':
            case 'CONFORT':
            case 'PREMIUM':
              if (el?.numberTickets?.value === "Si" /*|| el?.numberTickets?.value==="No"*/ || (Number(el?.numberTickets?.value) >= passager)) {
                return el
              }
              break;

            default:
              break;
          }
        }
      }
    } else {
      return el;
    }
  })
}
/**
 * @description función que coge la tarifa más barata dependiendo si es child or adult
 * @param tarifsList 
 * @param children 
 * @returns 
 */
function getFirstTarifRoundTrip(tarifsList: any[], children: boolean, discount?: boolean, passager?: any) {
  return tarifsList?.find(el => {
    if (el?.group) {
      if (!!discount) {
        if (el.group.type === "BASICO" && el.group.child === true) {
          return el
        }
        //return children ? el.group?.child && el.group.discount : !el.group?.child && el.group.discount;
      } else {
        if (el.group.child === children) {
          switch (el.group.type) {
            case 'BASICO':
            case 'ELIGE':
            case 'CONFORT':
            case 'PREMIUM':
              if (el?.numberTickets?.value === "Si" /*||el?.numberTickets?.value==="No" */ || (Number(el?.numberTickets?.value) >= passager)) {
                return el
              }

              break;

            default:
              break;
          }
        }
        /* if(el.group.type==="BASICO" &&el.group.child===children && (el?.numberTickets?.value==="Si" || (Number(el?.numberTickets?.value)>=passager)) ){
          return el
        }else if(el.group.type==="CONFORT" &&el.group.child===children  && (el?.numberTickets?.value==="Si" || (Number(el?.numberTickets?.value)>=passager)) ){
          return el
        } */
        //return children ? el.group?.child && !el.group.discount : !el.group?.child && !el.group.discount;

      }
    } else {
      return el;
    }
  })
}

/**
 * @description función que coge la tarifa más barata dependiendo si es child or adult
 * @param tarifsList 
 * @param children 
 * @returns 
 */
function getTarifByType(tarifsList: any[], children: boolean, tarifName: string) {
  tarifsList = tarifsList.filter((el: any) => el.group?.type === tarifName)
  return tarifsList.find(el => {
    if (el.group) {
      if (!el.group.discount) {
        return children ? el.group?.child : !el.group?.child;
      }
    } else {
      return el;
    }
  })
}

/**
 * @description función que calcula el precio del botón de seleccionar viaje
 * @param legs 
 * @returns 
 */
export function calcCurrentPrice(legs: any, _travellerList: any): { sum: number, desc: string } {
  let sum = 0;
  legs.forEach((leg: any) => {
    sum += leg.pricetag.price;
  })
  const twoDecimal = +sum.toFixed(2);
  return { sum: twoDecimal, desc: formatPrice(sum) + " €" };
}

/**
 * @description función que calcula el precio del botón de seleccionar viaje
 * @param legs 
 * @returns 
 */
export function calcCurrentPriceTotal(legs: any, _travellerList: any): { sum: number, desc: string } {
  let sum = 0;
  legs.forEach((leg: any) => {
    if (leg.pricetag.price === null && leg.pricetag.type === 'info') {
      sum += 0;
    }
    else if (leg.pricetag.price === 0 || leg.pricetag.price == null) {
      sum += leg.realPriceTag.price;
    }
    else {
      sum += leg.pricetag.price;
    }
  })
  const twoDecimal = +sum.toFixed(2);
  return { sum: twoDecimal, desc: formatPrice(sum) + " €" };
}

/**
 * @description Función que formatea el precio con coma y dos dígitos.
 * @param price Precio a formatear (string o numérico)
 * @returns Precio formateado en X,XX
 */
export function formatPrice(price: string | number) {
  let text = price + '';
  let coste = parseFloat(text).toFixed(2);
  let priceFormatted = coste.replace('.', ',');
  return priceFormatted;
}

const checkIfFromTo = (tarifaUnica: any) => {
  const allowedTariff = [EAveTarifTypes.IDA_Y_VUELTA];
  return allowedTariff.includes(tarifaUnica?.group?.type) && tarifaUnica?.group?.child === false && !tarifaUnica?.group?.discount;
}

/**
 * @description función que retorna un array de tarifas, que sacamos de los datos del viaje
 * @param tarifs 
 * @param trip 
 * @returns 
 */
export function setTarifs(tarifs: any, trip: any, childCounter: number, adultCounter: number, seatAvailableInSilentCar: boolean, returnTrainIsSelected: boolean, t?: any): any {

  const tarifSelected = trip?.pricetag?.shpCtx;
  const sameShpCtx = (element: any) => element?.shpCtx === tarifSelected;
  const indexSelected = tarifs?.findIndex(sameShpCtx);

  let output: any[] = []
  let transport = whatTransportIs(trip);
  tarifs.forEach((el: any, i: number) => {
    const isTarifSelected = i === indexSelected;
    const isFromTo = checkIfFromTo(el)
    const showSwitchSilentCar = isFromTo ||
      (seatAvailableInSilentCar && el.param.some((o: any) => o.name === "CLASS_TYPE" && o.value === "SITTING_TOURIST"));

    let baseItem: any = {
      id: i,
      color: trip?.line?.backgroundcolor,
      mode: el.desc,
      price: formatPrice(el.price) + "€",
      showCounter: false,
      shpCtx: el?.shpCtx,

    }
    if (transport === travelServices.train) {
      baseItem.numcounter = childCounter + adultCounter;
      baseItem.minNumCounter = 1;
      baseItem.numpersons = childCounter + adultCounter;
      baseItem.showCounter = false;
      baseItem.showdropdown = isTarifSelected;
    }
    if (transport === travelServices.ave) {
      let ticketLiteral = "";
      if (t) {
        ticketLiteral =
          el.numberTickets.value == 1
            ? t("setTarifsLiterals.ticketAvailable")
            : t("setTarifsLiterals.ticketsAvailable");
      }

      baseItem.hasDropdown = true;
      baseItem.toggled = false;
      baseItem.text = trip?.line?.text;
      baseItem.showSwitch = showSwitchSilentCar;
      baseItem.showdropdown = isTarifSelected;
      baseItem.isFromTo = isFromTo;
      baseItem.isTrainSelected = isFromTo ? returnTrainIsSelected : false;
      baseItem.ticketsAvailable = {
        number: el?.numberTickets?.value,
        text: `${el?.numberTickets?.value} ${ticketLiteral}`,
        color: calcColorsTickets(el?.numberTickets?.value),
        borderColor: calcColorsTickets(el?.numberTickets?.value)
      }
    }
    //Metemos en la array de tickets aquellos que tenemos plaza segun los pasajeros que somos
    if (el?.numberTickets?.value === "Si" || (Number(el?.numberTickets?.value) >= childCounter + adultCounter)) {
      output.push(baseItem);
    } else if (el?.numberTickets === undefined) {
      output.push(baseItem);
    }
  })
  return output;
}

/**
 * @description función que retorna si el item es un tren y tiene el botón de bono
 * @param trip 
 * @returns 
 */
export function getTarifBono(trip: any): boolean {

  let transport = whatTransportIs(trip);
  return transport == travelServices.train ? true : false
}

/**
 * @description función que retorna los literales para el detalle dependiendo del transporte
 * @param trip 
 * @returns 
 */
export function setTarifsLiterals(trip: any, t: any): any {
  //AQUI COSAS? //literales de la modal de bolt, no haria falta creo

  let transport = whatTransportIs(trip);
  let output = {
    "title": t("setTarifsLiterals.title"),
    "comment": t("setTarifsLiterals.comment"),
    "button": t("setTarifsLiterals.button"),
    "titlecounter": t("setTarifsLiterals.titlecounter"),
    "desccounter": t("setTarifsLiterals.desccounter"),
    "bono": t("setTarifsLiterals.bono"),
    "icons": [
      "passengers",
      "work"
    ]
  }
  if (transport === travelServices.train) {
    output.title = t("setTarifsLiterals.title2");
    output.titlecounter = t("setTarifsLiterals.titlecounter2");
    output.desccounter = t("setTarifsLiterals.desccounter2");
    output.button = t("setTarifsLiterals.button2");
    output.bono = t("setTarifsLiterals.bono2");
  }

  return output;
}

/**
 * @description función que retorna que transporte es, actualmente solo metidos trenes
 * @param trip 
 * @returns 
 */
export function whatTransportIs(trip: any): string {
  let output = "";
  if (trip.icon == "cercanias") output = travelServices.train;
  if (trip.icon == "ave") output = travelServices.ave;
  // if( trip.icon == "BOLT") output = travelServices.bolt;
  return output;
}

/**
 * @description función que comprueba si es andar o no, para pintar el detalle
 * @param icon 
 * @returns 
 */
export function checkIsWalk(icon: string): boolean {
  return icon === "andar" || icon === "transbordo" || icon === "unknown";
}

export function checkIsWalkByType(type: string): boolean {
  return type === "WALK";
}

/**
 * @description función que se usa para eliminar los items del detalle
 * @param trip 
 * @returns 
 */
function checkDetailDeleteItems(trip: any): any {
  let firstSetted: boolean = false;
  let firstIndex: number | null = null;
  let lastIndex: number | null = null;
  let transportsCounter: number = 0;
  let transportsIndex: any[] = []
  let output: boolean = false
  trip?.LegList?.Leg?.forEach((el: any, index: number) => {
    let { icon } = switchTransports(el)
    let isWalk: boolean = checkIsWalk(icon);
    if (!isWalk) {
      transportsCounter++;
      transportsIndex.push({
        index: index,
        icon: icon
      })
      /*if (!firstSetted) {
        firstSetted = true;
        firstIndex = index;
        transportsIndex.push({
          firstIndex:firstIndex,
          icon:icon
        })
      }
      lastIndex = index;*/
    }
  })
  /*if (typeof (firstIndex) == "number") output.push(firstIndex);
  if (typeof (lastIndex) == "number" && lastIndex != firstIndex) output.push(lastIndex);
  if (transportsCounter == 1) output = [];*/
  return mappingDelete(transportsIndex);
}

/**
 * @description Function that check show delete footers from a mapped trip
 * @param legs 
 * @returns a mapped trip, with news show delete footers
 */
export function checkMappedDeleteItems(legs: any[]): any[] {
  /*let indexes: any[] = [];
  let firstSetted: boolean = false;
  let firstIndex: number | null = null;
  let lastIndex: number | null = null;
  let transportsCounter: number = 0;
  legs.forEach((el: any, index: number) => {
    let isWalk: boolean = checkIsWalk(el.icon);
    if (!isWalk) {
      transportsCounter++;
      if (!firstSetted) {
        firstSetted = true;
        firstIndex = index;
      }
      lastIndex = index;
    }
  })
  if (typeof (firstIndex) == "number") indexes.push(firstIndex);
  if (typeof (lastIndex) == "number" && lastIndex != firstIndex) indexes.push(lastIndex);
  if (transportsCounter == 1) indexes = [];
  legs.forEach((el: any, index: number) => {
    el.showFooter = indexes.includes(index) ? true : false;
  })
  legs = orderIdPst(legs);
  return [...legs];*/
  legs = mappingDeleteAfter(legs)
  legs = orderIdPst(legs);
  return [...legs];
}

/**
 * @description función que ordena los legs por id
 * @param legs 
 * @returns 
 */
function orderIdPst(legs: any[]): any[] {
  legs.forEach((el: any, index: number) => {
    el.idPst = index.toString();
  })
  return [...legs];
}

/**
 * @description función para calcular las paradas de un item del detalle
 * @param leg 
 * @returns 
 */
function getStops(leg: any): string[] {
  let output: string[] = [];
  if (leg?.Stops?.Stop) {
    Object.values(leg.Stops.Stop).forEach((el: any) => output.push(el.name))
  } else {
    output.push(leg.Origin.name);
    output.push(leg.Destination.name);
  }
  return output;
}

/**
 * @description función que calcula el tiempo de cada viaje
 * @param trip 
 * @returns 
 */
function getTimeBetween(trip: any) {
  let [originHour, originMinutes, originSeconds] = trip.Origin.time.split(":")
  let [destinationHour, destinationMinutes, destinationSeconds] = trip.Destination.time.split(":")
  let originDate = new Date(trip.Origin.date.replace(/-/g, '/') + " " + trip.Origin.time)
  let destinationDate = new Date(trip.Destination.date.replace(/-/g, '/') + " " + trip.Destination.time)
  var diff = Math.abs((destinationDate as any) - (originDate as any));
  const originDay = originDate.getDate();
  const destinationDay = destinationDate.getDate();
  return { originDay, destinationDay, originHour, originMinutes, originSeconds, destinationHour, destinationMinutes, destinationSeconds, diff };
}

/**
 * @description función que calcula la cantidad de hojas a mostrar
 * @param rating 
 * @returns 
 */
function getEcologicSection(rating: number, co2: number) {
  const leafColor = getLeafClass(rating);
  let output = [];
  let initialCounter = 3;
  while (initialCounter > 0) {
    if (rating > 0) {
      output.push({
        "icon": "leafFull",
        "size": "24px",
        "iconFill": leafColor,
        "co2": co2
      })
    } else {
      output.push({
        "icon": "leafFull",
        "size": "24px",
        "iconFill": "icon-variant-5"
      })

    }
    initialCounter--;
    rating--;
  }
  return output;
}

function getTransportSection(legs: any, trip: any) {
  let output: any = [];
  
  legs.forEach((leg: any, index: number) => {
    let nameFloat = ""
    const { diff } = getTimeBetween(leg);
    const item = switchTransports(leg, Math.floor(diff / 1000 / 60), nameFloat);
    let tag: any;
    if (['cercanias'].includes(item.icon)) {
      tag = getTransportIcon(leg, leg.Product[0].line);
    }

    if (item.icon != "unknown") {
      /* YA NO SE FILTRA POR MENOS DE 5 MINUTOS PORQUE SINO ROMPE EL CALCULO DE LAS TARIFAS */
      // if (!(item.icon == "andar" && parseInt(item.text) < 5)) {
      output.push({ ...item, backgroundcolor: tag?.backgroundcolor || item?.background, bordercolor: tag?.bordercolor, color: tag?.color, idx: index }); // idx muy muy importante para transbordos metro y futuro refactor!!!!
      // } else{
      // output.push({});
      // }
    }

  })
  return output;
}


export enum ETransportLiterals {
  ave = "AVE Larga distancia",
  cercanias = "Cercanias",
  avant = "AVANT",
  train = "Tren no operado por renfe"
}

export function switchTransports(step: any, minutes?: number, nameTransport?: any) {
  let icon = "andar"
  let iconReal = "andar"
  let transportTypeString = "";
  let transportNameString = ""; // solo aplica a taxis
  switch (step.type) {
    case "TRSF":
      icon = "andar";
      iconReal = "transbordo"
      break;
    case "WALK":
      icon = "andar";
      iconReal = "andar";
      break;
    case "CHKI":
      icon = "ingreso";
      iconReal = "ingreso";
      break;
    default:
      switch (step.Product[0]?.cls) {
        case "2":
        case "4":
          if ((step.Product[0]?.operatorCode == "107" || step.Product[0]?.operator == "RENFE OPERADORA") && RenfeTrainCodesList.includes(step.Product[0]?.matchId || step.Product[0]?.name)) {
            icon = "ave";
            iconReal = "ave";
            transportTypeString = ETransportLiterals.ave;
            if (step.Product[0]?.name === "RENAVANT") {
              transportTypeString = ETransportLiterals.avant;
            } else {
              transportTypeString = ETransportLiterals.ave;
            }
          }
          // RENFE-CERCANIAS
          else if (step.Product[0]?.admin == "028000" || step.Product[0]?.operatorInfo?.id == "1071VC") {
            //Cercanias operado por Renfe
            icon = "cercanias"
            iconReal = "cercanias";
            transportTypeString = ETransportLiterals.cercanias;
          } else if (step.Product[0]?.admin == "030000" && step.Product[0]?.operator == "RENFE OPERADORA") {
            icon = "ave";
            iconReal = "ave";
            transportTypeString = ETransportLiterals.ave;
          }
          // CERCANIAS NO OPERADAS POR RENFE
          else {
            icon = "cercanias";
            iconReal = "tren";
            transportTypeString = ETransportLiterals.train;
          }
          break;
        default:
          iconReal = "unknown";
          icon = "unknown";
          break;
      }

  }
  // if(minutes > 5 && icon == "andar"){
  const isWalk: boolean = (icon === "andar" || icon === "transbordo");

  const backgroundStatic = getTransportColor(!!transportNameString ? transportNameString : icon);
  let transportIcon = {
    text: isWalk ? minutes?.toString() : step?.number || step?.Product[0]?.line || step?.Product[0]?.name || transportTypeString || "",
    backgroundcolor: isWalk ? '#fff' : backgroundStatic || 'black',
    color: isWalk ? '#000' : '#fff'
  };
  if (['cercanias'].includes(icon)) {
    transportIcon = getTransportIcon(step, isWalk ? minutes?.toString() : step?.number || step?.Product[0]?.line || step?.Product[0]?.name || transportTypeString || "");
  }

  const transport = {
    icon,
    iconReal,
    transportTypeString,
    size: "24px",
    background: backgroundStatic,
    idx: step.idx,
    ...transportIcon
  }
  return transport;
  // }
}

export function getProviderType(trip: any) {
  let type = "";
  switch (trip.type) {
    case "TRSF": type = "trsf"; break; // ?? que es eso
    case "WALK": type = "walk"; break;
    case "JNY": type = "cercanias"; break;
    default:
      switch (trip.Product[0]?.cls) {
        case "4": type = "cercanias"; break;
        case "128": type = "ave"; break;
        default: break;
      }
  }
  return type;
}

export function getProvider(trip: any) {
  // devuelve karhoo | movitaxi | bolt | renfe-cercanias | renfe-ave

  let provider: string | undefined;
  switch (trip.type) {
    case "TAXI":
      provider = trip.name.toLowerCase();
      break;
    default:
      if (RenfeTrainCodesList.includes(trip.Product[0]?.matchId)) {
        provider = "renfe-ave";
      } else {
        switch (trip.Product[0]?.cls) {
          case "4": provider = "renfe-cercanias"; break;
          // case "128": provider = "renfe-ave"; break;
          default: break;
        }
      }
  }
  return provider;
}

// TODO: CUBRIR CASUISTICAS SEGÚN TRANSPORTE (TAXI, AVE, CERCANIAS)
export function getContextPerPassenger(contexts: any, travellerList: any, type: string) {
  const tickets: Array<any> = [];
  if (type === 'taxivtc') {
    tickets.push({ context: contexts[0] })
  } else {
    travellerList.forEach((item: any, i: number) => {
      if (item?.type !== "BABY") {
        tickets.push({ context: contexts[i] || contexts[0] })
      }
    })
  }
  return tickets;
}

export function getContextPerPassengerByGroup(tarifs: any, travellerList: any, type: string) {
  const tickets: Array<any> = [];
  travellerList?.forEach((item: any, i: number) => {
    const adultTarif = getFirstTarifAux(tarifs, false);
    const childTarif = getFirstTarifAux(tarifs, true,);
    if (item?.type === "ADULT") {
      let tarif = adultTarif;
      tickets.push({ context: tarif?.shpCtx })
    } else if (item?.type === "CHILD") {
      let tarif = !!childTarif ? childTarif : adultTarif;
      tickets.push({ context: tarif?.shpCtx })
    } else {
      console.error("No se está mandando la tarifa correcta");
    }
  })
  return tickets;
}

function switchTransportsType(tripLeg: any) {
  let type = "walk";
  switch (tripLeg.type) {
    case "TRSF":
      break;
    case "WALK":
      break;
    case "TAXI":
      type = "taxiVtc";
      break;
    case "BIKE":
      switch (tripLeg.name) {
        case "cooltra":
          type = "moto";
          break;
        case "Reby eScooter":
          type = "patinete";
          break;
        default:
          type = "moto";
          break;
      }
      break;
    default:
      switch (tripLeg.Product[0]?.cls) {
        case "4":
          type = "ave";
          break;
        case "256":
          type = "busLD";
          // type = tripLeg.Product[0]?.catIn === "EMT" ? "busUrb" : "busLD";
          break;
        case "64":
          type = "metro";
          break;
        case "128":
          type = "ave";
          break;
        default:
          break;
      }
  }
  return type;
}

function getTravellerProfile(travellers: TravelPassengers) {
  let output: string[] = [];
  Object.keys(travellers.value).forEach((element: string, counter: number) => {
    // @ts-ignore
    let value = travellers.value[element];

    if (value) {
      switch (element) {
        case "more-than-13-counter":
          while (value > 0) {
            output.push(`RaaS_DEV.Traveller(age: 18, id: "traveler-${counter}", type: "ADULT")`)
            value--;
          }
          break;
        case "less-than-13-counter":
          while (value > 0) {
            value--;
            output.push(`RaaS_DEV.Traveller(age: 13, id: "traveler-${counter}", type: "CHILD")`)
          }
          break;
        case "less-than-3-counter":
          while (value > 0) {
            value--;
            output.push(`RaaS_DEV.Traveller(age: 3, id: "traveler-${counter}", type: "BABY")`)
          }
          break;
      }
    }
  })
  return output;
}
// hemos creado esta función porque para ida y vuelta el back acepta solo este formado
function getTravellerProfileTrainReturnVersion(travellers: TravelPassengers) {
  let output: any[] = [];

  Object.keys(travellers.value).forEach((element: string, counter: number) => {
    // @ts-ignore
    let value = travellers.value[element];

    if (value) {
      switch (element) {
        case "more-than-13-counter":
          while (value > 0) {
            output.push({
              "age": 18,
              "id": `traveler-${counter}`,
              "type": "ADULT"
            })
            value--;
          }
          break;
        case "less-than-13-counter":
          while (value > 0) {
            value--;
            output.push({
              "age": 13,
              "id": `traveler-${counter}`,
              "type": "CHILD"
            })
          }
          break;
        case "less-than-3-counter":
          while (value > 0) {
            value--;
            output.push({
              "age": 3,
              "id": `traveler-${counter}`,
              "type": "BABY"
            })
          }
          break;
      }
    }
  })
  return output;
}

export function getISODate(date: Date) {

  function pad(number: number) {
    if (number < 10) {
      return '0' + number;
    }
    return number;
  }

  let _date = new Date(date);

  return _date.getUTCFullYear() +
    '-' + pad(_date.getMonth() + 1) +
    '-' + pad(_date.getDate())
}




export function filterTripsFromService(initialTrips: any[], /* order: string,  */options: any) {
  let aux: any[] = []
  let transports: any[] = options.transportcard;
  if (initialTrips && initialTrips.length > 0) {

    //primero guardamos los transportes permitidos
    let transportsAllowed = ["walk"]
    transports.forEach((transport: any) => {
      if (transport.selected) transportsAllowed.push(transport.id) // si está seleccionado
    })

    // ahora recorremos los leg y vemos si tienen algún transporte no permitido
    initialTrips.forEach((el: any) => {
      let allowedTrip = true;
      if (el?.LegList?.Leg) {
        el.LegList.Leg.forEach((leg: any) => {
          const type = switchTransportsType(leg);
          if (transportsAllowed.includes(type)) { // AQUI COSAS
            //correcto
          } else {
            allowedTrip = false;
          }
        });
      } else {
        allowedTrip = false;
      }
      if (allowedTrip) aux.push(el);
    })
  }
  return aux;
}

function addZerosLeft(n: number | string) {
  n = n + '';
  return n.length >= 2 ? n : new Array(2 - n.length + 1).join('0') + n;
};
function formatTimeToLiteral(date: string | Date) {
  const dateObj = new Date(date);
  return `${addZerosLeft(dateObj.getHours())}:${addZerosLeft(dateObj.getMinutes())}`;
}
function formatWeekdayAndDateMonthToLiteral(date: string | Date) {
  const dateObj = new Date(date);
  return capitalice(dateObj.toLocaleDateString('es-ES', { weekday: 'long', month: 'short', day: 'numeric' }));
}
function capitalice(str: any) {
  str = str.toLowerCase();
  const capitalized = str.charAt(0).toUpperCase() + str.slice(1);
  return capitalized;
}
export interface TripDetail {
  "idPst": string,
  "tripId": string,
  "idTariff"?: any,
  "idPstNotChangeable": number,
  "transport": boolean,
  "icon"?: string,
  "transportTypeString"?: string,
  "isAproximetePriceElement"?: boolean,
  "isCarTransport"?: boolean,
  "isExternal"?: boolean,
  "departureTime"?: string,
  "arrivalTime"?: string,
  "direction"?: string,
  "showFooter"?: boolean,
  "tarifs"?: any[], // este array tiene las tarifas para utilizarlas en las modales
  "pricetag"?: any,
  "frecuency"?: string,
  "stops"?: string[],
  "direct"?: boolean,
  "line"?: UiTagData,
  "duration"?: string,
  "showDrivingLicense"?: boolean,
  "literals": any, // literales específicas para el pst.
  "pricePerTime": string
  "trip": any;
  "buttonsFooter"?: any[];
  "estimated"?: boolean;
  "departureDate": Date;
  "allTarifsList": any[], // aqui hay la lista completa de las tarifas
  "silentCar": any,
  "realPriceTag": any, // Aqui guardamos el pricetag por si cambiamos de "billete incluido" a precio real o compra externa.
  "fromToTrainTrip": any, // Aqui guardamos la lista/tarifas de los trenes de vuelta 
  "stationName": any // Cambia el informativo de la parada y el sentido (DOCO-679: Aplica solo a tren, metro, bus, tranvía, cercanías)
  "tarifsTransport": any,
  "messages": any,
  "paymentCard"?: paymentCard,
  "realTimeTrains"?: any
}

export interface paymentCard {
  icon: string; name: string; number: string; date: string
}

export function checkDeletedRoutes(array: any, index: any) {
  let result = true,
    onlyCercanias = [];
  onlyCercanias = array.filter((t: any) => t.icon !== "cercanias" && t.icon !== "andar")

  if (array) {
    // Comprobamos si el viaje es solo cercanias
    if (onlyCercanias.length == 0) {
      //transbordo de cercanías a otro cercanías pero el viaje es de solo cercanias no hacemos nada.
      if (array[index]?.icon === "cercanias" && (array[index - 1]?.icon === "cercanias" || array[index + 1]?.icon === "cercanias")) {
        return array
      }
      //el viaje no solamente de cercanias
    } else {
      //Si la ruta marcada es un cercanias y atras es otro cercanias borro
      if (array[index]?.icon === "cercanias" && (array[index - 1]?.icon === "cercanias")) {
        return array.splice(index - 1, 1);

        //Si la ruta marcada es un cercanias y delante es otro cercanias borro
      } else if (array[index]?.icon === "cercanias" && (array[index + 1]?.icon === "cercanias")) {

        return array.splice(index + 1, 1) && array.splice(index, 1);
      } else {
        array.splice(index, 1);
      }

    }

    //un cercanias y delante any y despues un cercanias no podemos borrar
    if (array[index]?.icon === "cercanias" && (array[index + 1]?.icon !== "cercanias" && array[index + 2]?.icon === "cercanias")) {
      return array;
    }
  } else {
    //Si no cumple niguno se borra normal
    return array.splice(index, 1);
  }
}

export function manageDeleteTransbordosMetros(indexDeleteItem: number, detailsSelector: Array<any>, t: Function) {
  /* Transbordo entre metros */ // TODO: REFACTORIZAR 

  let { icon } = detailsSelector[indexDeleteItem];
  const isMetro: boolean = icon === "metro";
  let isMetroTransbordo: boolean = false;
  if (isMetro) {

    const previousTwoSteps = detailsSelector[indexDeleteItem - 2]?.icon === "metro" ? detailsSelector[indexDeleteItem - 2] : {};
    const previousStep = detailsSelector[indexDeleteItem - 1]/*?.icon ==="metro" ? detailsSelector[indexDeleteItem -1]: {}*/;
    const continueStep = detailsSelector[indexDeleteItem + 1]/* ?.icon ==="metro" ? detailsSelector[indexDeleteItem +1]: {} */;
    const continueTwoStep = detailsSelector[indexDeleteItem + 2]?.icon === "metro" ? detailsSelector[indexDeleteItem + 2] : {};
    //isMetroTransbordo = isMetro &&

    //  previousTwoSteps?.icon ?
    //  previousTwoSteps.icon == "metro" && (previousStep.icon == "andar" || previousStep.icon == "transbordo") :

    //  previousStep?.icon ?
    //    previousStep.icon == "metro":

    //    continueStep?.icon ?
    //     continueStep.icon=="metro":

    //     continueTwoStep?.icon ?
    //     continueTwoStep.icon=="metro" && (continueStep.icon == "andar" || continueStep.icon == "transbordo")  :
    //     false;

    if (isMetro) {
      if (previousTwoSteps?.icon) {
        isMetroTransbordo = previousTwoSteps.icon == "metro" && (previousStep.icon == "andar" || previousStep.icon == "transbordo")
      }
          /* else */ if (!isMetroTransbordo && previousStep?.icon) {
        isMetroTransbordo = previousStep.icon == "metro";
      }
          /* else */ if (!isMetroTransbordo && continueStep?.icon) {
        isMetroTransbordo = continueStep.icon == "metro";
      }
          /* else */ if (!isMetroTransbordo && continueTwoStep?.icon) {

        isMetroTransbordo = continueTwoStep.icon == "metro" && (continueStep.icon == "andar" || continueStep.icon == "transbordo");
      }
    }


    if (isMetroTransbordo && continueStep?.icon === "metro") {
      detailsSelector[indexDeleteItem + 1].pricetag = externalBuy(t, detailsSelector[indexDeleteItem].pricetag?.price);
    } else if (isMetroTransbordo && continueTwoStep?.icon === "metro") {
      detailsSelector[indexDeleteItem + 2].pricetag = externalBuy(t, detailsSelector[indexDeleteItem].pricetag?.price);
    }
  }

  return detailsSelector

}




function getTrainTime(paramsList: any, timeType: "DEPARTURE_TIME" | "ARRIVAL_TIME") {
  const time = paramsList?.find((param: any) => param?.name === timeType)?.value;
  const mappedHour = time.toString().match(/.{2}/g).join(':');
  return mappedHour;
}

function addHourAtDate(hour: string): any {
  return new Date('1970-01-01 ' + hour);
}

function getDifferenceHour(arrivalTime: string, departureTime: string) {
  const diff = addHourAtDate(arrivalTime) - addHourAtDate(departureTime);
  const totalTime = `${Math.floor(diff / 1000 / 60 / 60)}h ${diff / 1000 / 60 % 60}min`;

  return {
    totalTime,
    diff
  }
}

function mapReturnAveModalTarif(returnTrainList: any, tripObject: any) {
  const trainList = returnTrainList?.filter(Boolean);
  return (trainList || []).map((item: any, index: number) => {
    const shpCtx = item?.ticket?.shpCtx;
    const departureTime = getTrainTime(item?.param, "DEPARTURE_TIME");
    const arrivalTime = getTrainTime(item?.param, "ARRIVAL_TIME");
    const differenceTime = getDifferenceHour(arrivalTime, departureTime);

    return {
      fromToSelected: index === 0,
      fromToID: shpCtx,
      tripOptions: {
        departureTime: `${departureTime} - ${arrivalTime}`,
        totalTime: differenceTime?.totalTime,
        tripDayPlanified: true,
        price: `${formatPrice(item?.ticket?.price / 100)} €`,
        ecologicSection: [
          {
            icon: "leafFull",
            size: "24px",
            iconFill: "color-ecologic-green",
          },
          {
            icon: "leafFull",
            size: "24px",
            iconFill: "color-ecologic-green",
          },
          {
            icon: "leafFull",
            size: "24px",
            iconFill: "color-ecologic-green",
          },
        ],
        trasportSection: [
          {
            icon: "ave",
            transportTypeString: "AVE Larga distancia",
            text: tripObject?.line?.text,
            size: "24px",
            backgroundcolor: tripObject?.line?.backgroundcolor,
            idx: 0,
          },
        ],
        hideDetail: false,
        hasExternalBuy: true,
      },
      literals: {
        moreText: "màs",
        updateText: "Actualizar precio",
        externalBuy: "Compra externa",
      },
      isFromTo: true,
      tarif: item,
      outwardTrip: tripObject
    }

  })
}


export function getReturnAveModalTarif(isFromToTrainTripArray: any) {
  let returnTrainTarif: any[] = [];
  isFromToTrainTripArray?.forEach((item: any) => {
    const returnTrainList = item?.fromToTrainTrip?.returnTrainList;
    const fromToTickets = returnTrainList && mapReturnAveModalTarif(returnTrainList, item);
    returnTrainTarif[item?.idPst] = fromToTickets;
  })
  return returnTrainTarif;

}

export function setReturnTrainSelectedList(isFromToTrainTripArray: any): IReturnTrainStateControlObject[] {
  let returnTrainSelectedList: IReturnTrainStateControlObject[] = [];

  isFromToTrainTripArray?.forEach((item: any) => {
    returnTrainSelectedList[item?.idPst] = {
      isFromToTarifSelected: false,
      isTrainReturnSelected: false,
      trainReturnTarifSelected: ""
    };
  })
  return returnTrainSelectedList;
}

export function checkIfReturnTrainIsSelected(returnTrainObjectControl: IReturnTrainStateControlObject | undefined): boolean {
  return !returnTrainObjectControl
    ? true
    : returnTrainObjectControl?.isFromToTarifSelected && returnTrainObjectControl?.isTrainReturnSelected && !!returnTrainObjectControl?.trainReturnTarifSelected;
}

function getNewTransportSection(mappedDetailObject: IMappedDetailObject[]) {
  let returnNewTransportSection: Line[] = []
  return mappedDetailObject.map((oneTransport: IMappedDetailObject, index: number) => {
    return returnNewTransportSection[index] = {
      icon: "ave",
      transportTypeString: "AVE Larga distancia",
      text: oneTransport?.line?.text,
      size: "24px",
      backgroundcolor: oneTransport?.line?.backgroundcolor,
      idx: +oneTransport?.idPst // tengo dudas
    }
  })
}

function mapReturnRouteBox(mappedDetailObject: IMappedDetailObject[], departureSelectedTrip: any) {
  const totalDepartureTime = mappedDetailObject[0].departureTime;
  const totalArrivalTime = mappedDetailObject[mappedDetailObject.length - 1].arrivalTime;
  const totalDifenceHour = getDifferenceHour(totalArrivalTime, totalDepartureTime);
  const totalPrice = mappedDetailObject.reduce((accumulatorValue, actualValue) => accumulatorValue + actualValue?.pricetag?.price, 0)

  return {
    fromToSelected: mappedDetailObject.every(item => item.fromToTrainTrip.isFromToTrainTrip),
    fromToID: mappedDetailObject[0].realPriceTag.shpCtx, // que asignmos aqui sino?
    tripOptions: {
      departureTime: `${totalDepartureTime} - ${totalArrivalTime}`,
      totalTime: totalDifenceHour?.totalTime,
      tripDayPlanified: true,
      price: `${formatPrice(totalPrice)} €`,
      ecologicSection: [
        {
          icon: "leafFull",
          size: "24px",
          iconFill: "color-ecologic-green",
        },
        {
          icon: "leafFull",
          size: "24px",
          iconFill: "color-ecologic-green",
        },
        {
          icon: "leafFull",
          size: "24px",
          iconFill: "color-ecologic-green",
        },
      ],
      trasportSection: getNewTransportSection(mappedDetailObject),
      literals: {
        moreText: "màs", // hay que traducir esto
      },
      isFromTo: true,
    },
    departureTrip: departureSelectedTrip
  }
}


function mapPriceTag(item: IReturnTrainStateControlObject, payedPassengerNumber: number) {
  const departurePst = item?.outwardTripPst;
  const tarifSelected = item?.tarifSelected;
  const tarifPrice = tarifSelected?.ticket?.price / 100
  const totalPricePerPassenger = tarifPrice * payedPassengerNumber;
  const twoDecimalNumber = +totalPricePerPassenger.toFixed(2);

  return {
    id: departurePst?.idPst,
    isSilentCar: false,
    price: twoDecimalNumber,
    shpCtx: tarifSelected?.ticket?.shpCtx,
    text: `${formatPrice(totalPricePerPassenger)} € - ${tarifSelected?.ticket?.name}`,
    type: "info"
  }

}

function mapReturnAveDetail(shpCtxReturnTrainSelectedArray: IReturnTrainStateControlObject[], payedPassengerNumber: number, planningObj: PlanningObject) {
  const arrivalDate = planningObj?.arrivalDate?.value;
  const departureDate = new Date(arrivalDate).toISOString().slice(0, 10);

  return shpCtxReturnTrainSelectedArray?.map((item: IReturnTrainStateControlObject) => {
    const departurePst = item?.outwardTripPst;
    const returnTrainTarifList = departurePst?.fromToTrainTrip?.returnTrainList?.map((item: any) => {
      return {
        ...item?.ticket,
        price: item?.ticket?.price / 100
      }
    });
    const trainTripCardInfo = item?.trainTripCardInfo;
    const dateTrain = trainTripCardInfo?.departureTime?.split(" - ");
    const stopsReverse = departurePst?.stops;

    return {
      ...departurePst,
      allTarifsList: returnTrainTarifList,
      arrivalTime: dateTrain[1],
      departureTime: dateTrain[0],
      departureDate: departureDate,
      direction: stopsReverse[stopsReverse?.length - 1],
      duration: trainTripCardInfo?.totalTime,
      transport: true,
      stops: stopsReverse,
      tarifs: returnTrainTarifList,
      showFooter: false,
      pricetag: mapPriceTag(item, payedPassengerNumber),
      realPriceTag: mapPriceTag(item, payedPassengerNumber)
    }
  });
}

export function mapReturnFromToAveDetail(shpCtxReturnTrainSelectedArray: IReturnTrainStateControlObject[], payedPassengerNumber: number, departureSelectedTrip: any, planningObj: PlanningObject) {
  const revertTrip = shpCtxReturnTrainSelectedArray.filter(Boolean)
  const mappedDetail = mapReturnAveDetail(revertTrip, payedPassengerNumber, planningObj);
  const mappedRouteBox = mapReturnRouteBox(mappedDetail, departureSelectedTrip);
  setItemStorage(SessionStorageItems.RAAS_RETURN_FROM_TO_AVE, mappedDetail);
  setItemStorage(SessionStorageItems.RAAS_RETURN_FROM_TO_ROUTE_BOX, mappedRouteBox);

}

export function calcEco(trips: any) {
  let co2List = trips.map((el: any) => el?.sortInfo?.co2 === undefined ? 10 : el?.sortInfo?.co2)
  var min = Math.min(...co2List)
  const aux = trips?.map((item: any, index: number) => {
    return {
      ...item,
      ecologicSection: item?.ecologicSection?.map((e: any) => {
        return {
          ...e,
          ecologic: item?.sortInfo?.co2 === min ? 3 : 0
        }
      }),
      sortInfo: {
        ...item?.sortInfo,
        ecologic: item?.sortInfo?.co2 === min ? 3 : 0
      }

    }
  })
  return aux

}

/**
 * Funcion para sacar todas las tarifas de transportes
 * @param trip 
 * @returns 
 */
export function getTarifsTransport(trip: any) {
  return trip?.TariffResult?.fareSetItem?.map((item: any) => {
    return {
      toLegId: item?.toLegId,
      fareItem: item?.fareItem?.map((e: any) => {
        return {
          name: e.ticket[0]?.name,
          price: formatPrice(e.ticket[0]?.price / 100) + '€',
          param: e.ticket[0]?.param[0]?.value,
        }
      }),
    }
  })
}

/**
 * Filtro para obtener tarifas transporte publico
 */
export function filterTarifsPublicTransport(trip: any, isExternal: boolean, tarifsTransport: any) {

  if (tarifsTransport) {
    if (isExternal == true) {
      return tarifsTransport.filter((item: any) => item.toLegId === trip.idx && item.fareItem);
    }
  } else {
    return []
  }



}

export function calcPriceCercaniasTag(tarifsArray: any, tarifsArrayAdult: any, t: any, icon: any, travellersList: any) {
  let price = getTotalPriceFromtravellerList(tarifsArray, travellersList);
  const transportTypes = ["moto", "patinete", "busLD", "metro"]
  const basicTarif = getFirstTarif(tarifsArray, false, false);

  return tarifsArray?.length > 0 && icon !== "andar" ? {
    price,
    text: `${formatPrice(price)} € - ${tarifsArrayAdult[0]?.desc}`,
    type: tarifsArray?.length > 0 && !transportTypes.includes(icon) ? "button" : "info",
    id: basicTarif?.id,
    shpCtx: basicTarif?.shpCtx,
    idTariff: basicTarif?.idTariff,
  } : {
    price: 0,
    text: `${t("literals.requiresExternalPurchase")} (${t("literals.requiresExternalPurchaseNoPrice")})`,
    type: "warn"
  }
}

export function calcPriceTag(tarifsArray: any, tarifsArrayAdult: any, t: any, icon: any, travellersList: any) {
  let children = travellersList.value["less-than-13-counter"];
  let adults = travellersList.value["more-than-13-counter"];

  const isFromTo = tarifsArray?.some((item: any) => { return !!item.isFromTo });

  const sortedArray = isFromTo ? tarifsArray?.sort((a: any, b: any) => { return b.price - a.price }) : tarifsArray;

  let price = getTotalPriceFromtravellerList(sortedArray, travellersList);
  const transportTypes = ["moto", "patinete", "busLD", "metro"];
  const basicTarif = getFirstTarif(sortedArray, false, false, adults + children);

  return sortedArray?.length > 0 && icon !== "andar" ? {
    price,
    text: `${formatPrice(price)} € - ${basicTarif?.desc}`,
    type: sortedArray?.length > 0 && !transportTypes.includes(icon) ? "button" : "info",
    id: basicTarif?.id,
    shpCtx: basicTarif?.shpCtx,
    idTariff: basicTarif?.idTariff,
  } : {
    price: 0,
    text: t("literals.mainTicketIncluded"),
    type: "info",
    informative: true,
  }
}


